module.exports = __webpack_public_path__ + "img/platform_03_level.b3094641.png";